// React
import * as React from "react";

// Model
import GlobalAuthenticatedContextModel from "./GlobalAuthenticatedContextModel";

const GlobalAuthenticatedContext = React.createContext(GlobalAuthenticatedContextModel);
export default GlobalAuthenticatedContext;